import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";
import axios from "axios";
import {components} from "react-select";

const SelectAsyncPaginate = (props) => {
  const [coinName, setCoinName] = useState(null);
  const [optionsNetworks,setOptionsNetworks] = useState([])
    const [DepositAddresses,setDepositAddresses] = useState([])
    const [chains,setChains] = useState('')

    const { SingleValue, Option } = components;


    const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </SingleValue>
);

const IconOption2 = (props) => (
    <Option {...props}>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </Option>
);



  useEffect(() => {
    setCoinName(props.coinName);
  }, [props.coinName]);

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
      setOptionsNetworks([])
      console.log(props.type)

    const response =  await axios.get('https://api.sinatether.com/Auth/GetChainsCurrency/', {
                params: {"curr": coinName,"type":props.type}
            }).then((res) => {
                if (res.status == 200) {
                   


                    setChains(res.data['chains'])
                    res.data['chains'].map((chain)=>(
                        optionsNetworks.push({label: chain['chainName'],value: chain['chainName']})

                    ))




                }
            })

    return {
      options: optionsNetworks,
      hasMore: false,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = async (option) => {
    if (typeof props.onChange === "function") {
      props.getDeposit([])
      props.onChange(option);
      if (props.type == 'withdraw'){



        await axios.get('https://api.sinatether.com/Auth/GetDWit/',{
                params:{"curr":coinName , "chain":option['value']}
            }).then((res)=>{


                props.getDeposit(res.data['result'])
                
           
          

        })



      

      }else if (props.type == 'deposit'){

           await axios.get('https://api.sinatether.com/Auth/GetDepositAddresses/',{
                params:{"curr":coinName , "chain":option['value']}
            }).then((res)=>{

               console.log(res.data['DepositAddresses'])

                props.getDeposit(res.data['DepositAddresses'])
                
           
          

        })

    }
  }
  
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify(coinName)}
      value={props.value || ""}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.value}
      getOptionLabel={(option) => option.value}
      onChange={onChange}
      isSearchable={false}
      placeholder="شبکه مدنظر را انتخاب کنید"
      additional={{
        page: 1,
      }}
       components={{
           SingleValue: IconSingleValue2,
           Option: IconOption2
       }}
      noOptionsMessage={() => "هیج موردی یافت نشد"}
      loadingMessage ={() => "درحال بارگیری..."}
    />
  );
};

SelectAsyncPaginate.propTypes = {
  coinName: PropTypes.string.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default SelectAsyncPaginate;
